import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyDgygq93TXY-tE5VcASQE5CXSPxR29ShP0",
	authDomain: "go-pang-6498a.firebaseapp.com",
	projectId: "go-pang-6498a",
	storageBucket: "go-pang-6498a.firebasestorage.app",
	messagingSenderId: "723575484304",
	appId: "1:723575484304:web:2a9a15237002d7b053cd15",
	measurementId: "G-CVZRS5947W",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

let analytics;
analytics = getAnalytics(firebaseApp);

const initAnalytics = async () => {
	if (await isSupported()) {
		analytics = getAnalytics(firebaseApp);
	}
};

const InitPageView = () => {
	const location = useLocation();
	useEffect(() => {
		logEvent(analytics, "page_view", {
			page_path: location.pathname,
			page_location: window.location.href,
			page_title: document.title,
		});
	}, [location]);
};

const eventPurchase = ({
	value,
	currency = "IDR",
	bmIdx = 0,
	bmCnt = 0,
	point = 0,
	cash = 0,
}) => {
	logEvent(analytics, "purchase", {
		value: value,
		currency: currency,
		items: [
			{
				bmIdx: bmIdx,
				bmCnt: bmCnt,
				point: point,
				cash: cash,
			},
		],
	});
};

export { firebaseApp, analytics, initAnalytics, eventPurchase };
